var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"drawer-detail"},_vm._l((_vm.fields),function(field){return _c('div',{key:field,staticClass:"field-type"},[_c('span',{staticClass:"label"},[_vm._v(_vm._s(_vm.translateTag[field] || field)+":")]),_c('SearchTagInputShow',{attrs:{"value":_vm.company[field]},on:{"quickEdit":function($event){return _vm.quickEdit(field)}}})],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }